<template>
  <v-app>
    <!-- Banner-style toolbar -->
    <v-app-bar app color="#dea061" elevation="0" height="80" class="app-bar-with-border center-toolbar-content">
      <v-app-bar-nav-icon v-if="smAndDown" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="header">Toronto Fire Fan</v-toolbar-title>
    </v-app-bar>

    <!-- Secondary navigation bar -->
    <v-app-bar color="#dea061" height="40" v-if="!smAndDown" :app="!smAndDown">
      <v-tabs class="d-none d-sm-flex w-100" align-tabs="center" v-model="activeTab" color="primary">
        <v-tab v-for="item in navigationItems" :key="item.name" :to="item.path" :value="item.name" class="nav-tab">
          {{ item.title }}
        </v-tab>
      </v-tabs>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer app v-model="drawer" temporary v-if="smAndDown" class="nav-tab">
      <v-list>
        <v-list-item v-for="item in navigationItems" :key="item.name" :to="item.path" :value="item.name"
          @click="drawer = false">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="mt-32">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import { useDisplay } from 'vuetify'

const activeTab = ref('map')
const drawer = ref(false)
const { smAndDown } = useDisplay()

const navigationItems = [
  {
    title: 'Active Incidents',
    name: 'map',
    path: '/'
  },
  {
    title: 'Fire Stations',
    name: 'fire-stations',
    path: '/fire-stations'
  },
  {
    title: 'Statistics',
    name: 'statistics',
    path: '/statistics'
  },
  {
    title: 'Glossary',
    name: 'glossary',
    path: '/glossary'
  },
  {
    title: 'Disclaimer & Site Info',
    name: 'disclaimer',
    path: '/disclaimer'
  }
]
</script>

<style scoped>
.app-bar-with-border {
  border-bottom: 3px solid #a11128;
}

.center-toolbar-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.center-toolbar-content .v-toolbar-title.header {
  margin: 0 auto;
}

.header {
  align-items: center;
  background-color: #dea061;
  color: #a11128;
  display: flex;
  font-family: sans-serif;
  font-size: 3em;
  justify-content: center;
  line-height: 1.2;
  padding: 0.2em 0;
}

.nav-bar-with-border {
  border-bottom: 3px solid #a11128;
}

.nav-tab {
  background-color: #dea061;
  color: #a11128;
  font-size: 0.8em;
}

@media (max-width: 600px) {
  .center-toolbar-content .v-toolbar-title.header {
    font-size: 2em;
  }

  .header {
    font-size: 2em;
  }
}
</style>
